import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';
import { normalizeTerms } from '../utils/terms';

// Satser for ventetid, bomtur og avbestilling (settings/terms) i sanntid.
// Gir alltid et normalisert terms-objekt: standardverdier før data, uten dokument og ved lesefeil.
export function useTerms() {
  const [terms, setTerms] = useState(() => normalizeTerms({}));
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    return onSnapshot(doc(db, 'settings', 'terms'), snap => {
      setTerms(normalizeTerms(snap.exists() ? snap.data() : {}));
      setError(false);
      setLoading(false);
    }, err => {
      console.error('useTerms:', err);
      setTerms(normalizeTerms({}));
      setError(true);
      setLoading(false);
    });
  }, []);

  // loaded: første svar (data eller feil) er kommet. error: lesingen feilet, og terms er standardsatsene.
  return { terms, loading, loaded: !loading, error };
}
